import { Resources, type TFunction } from "Translations/Resources";
import { z } from "zod";

export const SENTRY_REPORT_NAME_MAX_LENGTH = 100;
export const SENTRY_REPORT_MESSAGE_MIN_LENGTH = 10;
export const SENTRY_REPORT_MESSAGE_MAX_LENGTH = 2000;

const RESOURCES = Resources.Sentry.Validation;

// Name and e-mail stay optional here — matching how Sentry's own widget behaved,
// where only the description was required. For a signed-in user they aren't asked
// for at all; the identity comes from the session.
export const getSentryReportSchema = (t: TFunction) =>
  z.object({
    message: z
      .string()
      .trim()
      .min(1, { error: t(RESOURCES.MessageRequired) })
      .min(SENTRY_REPORT_MESSAGE_MIN_LENGTH, {
        error: t(RESOURCES.MessageTooShort, {
          minLength: SENTRY_REPORT_MESSAGE_MIN_LENGTH,
        }),
      })
      .max(SENTRY_REPORT_MESSAGE_MAX_LENGTH),
    name: z.string().trim().max(SENTRY_REPORT_NAME_MAX_LENGTH),
    email: z
      .string()
      .trim()
      .refine((email) => !email || z.email().safeParse(email).success, {
        error: t(RESOURCES.EmailInvalid),
      }),
  });

export type SentryReportFormData = z.infer<
  ReturnType<typeof getSentryReportSchema>
>;
